

/*
Archivo queda sin efecto debido a carga dinamica 
por rol de usuario en base de datos
*/

export default {
  items: [
    {
      name: 'Inicio',
      url: '/inicio',
      icon: 'fa fa-home',
      badge: {
        variant: 'primary',
        text: ''
      }
    },
    {
      title: true,
      name: 'Menu',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Recepción',
      url: '/recepcion',
      icon: 'fa fa-truck',
      children: [
        {
          name: 'Ingreso',
          url: '/recepcion/ingreso',
          icon: 'fa fa-hand-o-right'
        },
        {
          name: 'Consultas',
          url: '/recepcion/consultas',
          icon: 'fa fa-hand-o-right'
        }
      ]
    }
  ]
}
